// extracted by mini-css-extract-plugin
module.exports = {"newGameContainer":"NewGame_newGameContainer__1_yfN","newGameHeading":"NewGame_newGameHeading__1x763"};